<script setup lang="ts">
import { computed } from 'vue';
import StrategyResultCardScaffold from './StrategyResultCardScaffold.vue';
import type { CalculationMode } from '@fire-calc/domain-ts';

interface Props {
  mode: CalculationMode;
  subheader?: string;
  heroLabel: string;
  heroUnit: string;
  heroValue: string;
  heroSuffix?: string;
  bridgeText: string;
  fireNumber: string;
  fireNumberTooltip?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
  subheader: 'Ročně budete vybírat 4 % z portfolia.',
  fireNumberTooltip: '',
});

const resolvedSubheader = computed<string>(() => props.subheader);
const resolvedFireNumberTooltip = computed<string>(() => props.fireNumberTooltip ?? '');
</script>

<template>
  <StrategyResultCardScaffold
    tone="traditional"
    title="Tradiční"
    :subheader="resolvedSubheader"
    :hero-unit="heroUnit"
    :hero-label="heroLabel"
    :hero-value="heroValue"
    :hero-suffix="heroSuffix ?? ''"
    :bridge-text="bridgeText"
    :fire-number="fireNumber"
    :fire-number-tooltip="resolvedFireNumberTooltip"
  />
</template>
